import api from "./api";
export const login = (email, password) => api
    .post("/vendor/auth/login", { email, password })
    .then((r) => r.data);
export const verifyLoginOtp = (session_id, otp) => api
    .post("/vendor/auth/login/verify", { session_id, otp })
    .then((r) => r.data);
export const resendLoginOtp = (session_id, via) => api
    .post("/vendor/auth/login/resend", { session_id, via })
    .then((r) => r.data);
export const verifyEmail = (token) => api
    .get(`/vendor/auth/verify-email?token=${token}`)
    .then((r) => r.data);
export const register = (name, surname, business_name, email, phone, password) => api
    .post("/vendor/auth/register", {
    name,
    surname,
    business_name,
    email,
    phone,
    password,
})
    .then((r) => r.data);
export const forgotPassword = (email) => api
    .post("/vendor/auth/forgot-password", { email })
    .then((r) => r.data);
export const verifyForgotOtp = (session_id, otp) => api
    .post("/vendor/auth/forgot-password/verify", { session_id, otp })
    .then((r) => r.data);
export const resetPassword = (token, password) => api
    .post("/vendor/auth/reset-password", { token, password })
    .then((r) => r.data);
export const getMyProfile = () => api
    .get("/vendor/auth/me")
    .then((r) => r.data);
export const updateMyProfile = (patch) => api
    .patch("/vendor/auth/me", patch)
    .then((r) => r.data.user);
export const updateVendorOrg = (patch) => api
    .patch("/vendor/auth/org", patch)
    .then((r) => r.data.vendor);
export const uploadImage = (file) => {
    const form = new FormData();
    form.append("file", file);
    return api
        .post("/vendor/upload/public", form)
        .then((r) => r.data.url);
};
